export default __webpack_public_path__ + "static/tag-do-1-dark-de8fbfaa83066c6373bc21ec4917fa7a00d3d2269255cce2a69500fe8669a907.png";